import axios from '../../../services/axios-config';


export async function handleSaveTrial({value, setShowButton, setLoading, type}){
    try{
        setLoading(true);

        
        const res = await axios.post(`/admin/params/trial/update/${type}`, {
            value: value
        })

        if(res.status == 201){
            setShowButton(false);
        }

    } catch (error) {
        console.error('ERROR - HANDLE SAVE TRIAL:', error);
        throw error;
    
    } finally {
        setLoading(false);
    }
}